import { render, staticRenderFns } from "./ButtonGroupFieldtype.vue?vue&type=template&id=3847dcc1&"
import script from "./ButtonGroupFieldtype.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports